import { toast } from "react-toastify";

toast.configure();

export const getErrorToast = (message, time = 1000) => {
  return toast.error(message, {
    position: "top-right",
    autoClose: time,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
};

export const getWarningToast = (message, time = 2000) => {
  return  toast.warn(message, {
    theme: "colored",
    position: "top-right",
    autoClose: time,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};

export const getSuccessToast = (message, time = 1000) => {
  return toast.success(message, {
    position: "top-right",
    autoClose: time,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
};

export const untimeToast = (message) => {
  return toast.error(message, {
    position: "top-right",
    autoClose: false,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
};

export const warningTost = (massage) =>{
  getWarningToast(massage, 2000)
  return;
}

export const errorToast = (message, time) => {
  return toast.error(message, {
    position: "top-right",
    autoClose: time,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
};